module.exports = __webpack_public_path__ + "static/media/TCO_EN.2044f44e.png";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/TCO_EN.png
// module id = 1508
// module chunks = 0